/* ⭐ R560 · Zweck-Fenster (Oldtimer / Weiterleitung) und Oldtimer-Fahrzeugliste.
 *
 * Marcel 24.09.2026: „ein eigenes Oldtimer Formular und Popup und für Weiterleitung, sodass das je Zweck
 * richtig funktioniert und die Leute abholt." Markup: snippets/usparts-zweck-fenster.liquid,
 * snippets/usparts-oldtimer-formular.liquid, snippets/usparts-wl-formular.liquid.
 *
 * 1. Öffnen: [data-usp-zweck-open="oldtimer|weiterleitung"], Links mit ?teil=Oldtimer, und auf der
 *    Oldtimer- bzw. Weiterleitungsseite die allgemeinen Anfrage-Knöpfe (Tab-Leiste, Schwebe-Knopf).
 *    Läuft in der Capture-Phase am document — vor dem VIN-Fenster in usparts.js.
 * 2. Oldtimer-Liste: Hersteller → Modell aus assets/usp-oldtimer-fahrzeuge.json, „selbst eintragen"
 *    schreibt ins selbe Feld. Ohne JavaScript bleiben es freie Textfelder.
 * 3. Weiterleitung: USt-IdNr. nur bei „Gewerbe".
 */
(function () {
  'use strict';
  var html = document.documentElement;
  var body = document.body;
  var fenster = function (zweck) { return document.querySelector('[data-usp-zweck="' + zweck + '"]'); };
  var offen = null, letzterFokus = null;

  function oeffnen(zweck, teil) {
    var m = fenster(zweck); if (!m) return false;
    if (offen && offen !== m) schliessen();
    letzterFokus = document.activeElement;
    m.hidden = false; offen = m;
    html.style.overflow = 'hidden';
    if (teil) { var t = m.querySelector('[name="contact[Gesuchtes Teil]"], [name="contact[Teil]"]'); if (t && !t.value && !/^oldtimer$/i.test(teil)) t.value = teil; }
    var erstes = m.querySelector('.usp-ot__form input:not([type=hidden]), .usp-ot__form select');
    if (erstes && window.matchMedia('(pointer: fine)').matches) { try { erstes.focus({ preventScroll: true }); } catch (_) {} }
    if (zweck === 'oldtimer') liste(m);
    return true;
  }
  function schliessen() {
    if (!offen) return;
    offen.hidden = true; offen = null;
    html.style.overflow = '';
    if (letzterFokus && letzterFokus.focus) { try { letzterFokus.focus({ preventScroll: true }); } catch (_) {} }
  }

  var seite = body.classList.contains('usp-vorlage-oldtimer') ? 'oldtimer'
    : body.classList.contains('usp-vorlage-weiterleitung') ? 'weiterleitung' : null;

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-usp-zweck-close]') || (offen && e.target === offen)) { e.preventDefault(); schliessen(); return; }
    var knopf = e.target.closest('[data-usp-zweck-open]');
    var zweck = knopf ? knopf.getAttribute('data-usp-zweck-open') : null;
    var teil = null;
    if (!zweck) {
      var link = e.target.closest('a[href*="/pages/us-autoteile-teileanfrage"], a[href*="/pages/anfrage"]');
      // 29.09.2026 — Regel der Leitung: „Knöpfe (.usp-btn / .usp-fitment__cta-btn / Marker) öffnen das Fenster, Textlinks und Kacheln führen zur Seite, Kopf- und Fußgruppe navigieren immer.“
      // Hier nur die Kopf-/Fuß-Ausnahme: Navigation führt auch auf der Oldtimer- und Weiterleitungsseite auf die Anfrageseite.
      // Das Oldtimer-Zweckfenster für Inhalts-Links bleibt, wie es ist. Anlass und Knopf-Regel: usparts.js.
      if (link && link.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')) return;
      if (link) { try { teil = new URL(link.href, location.origin).searchParams.get('teil'); } catch (_) {} }
      if (link && teil && /oldtimer|klassiker/i.test(teil)) zweck = 'oldtimer';
      else if (seite) {
        // Allgemeine Anfrage-Knöpfe ([data-usp-request-open]: Tab-Leiste, Schwebe-Knopf, Schublade) öffnen auf
        // der Oldtimer- bzw. Weiterleitungsseite das passende Fenster. Reine Textlinks auf die Anfrageseite
        // bleiben auf der Weiterleitungsseite die VIN-Anfrage (Komplettangebot) — auf der Oldtimer-Seite nicht.
        var req = e.target.closest('[data-usp-request-open]');
        if (req && req.getAttribute('href') && req.getAttribute('href').charAt(0) === '#') req = null; // Sprungmarke (z. B. zum Rechner)
        if (req || (link && seite === 'oldtimer')) zweck = seite;
      }
    }
    if (!zweck || !fenster(zweck)) return;
    e.preventDefault(); e.stopPropagation();
    oeffnen(zweck, teil);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offen) schliessen(); });

  /* ── App-Popups weichen dem Ausfüllen (25.09., usp-r560.css html.usp-form-fokus) ──
     Fokus in einem Formular an /contact → Klasse an. Verlassen → nach 1,5 s wieder aus, falls der Fokus nicht in ein
     anderes solches Formular gewandert ist (am iPhone nimmt der Absende-Knopf keinen Fokus: ohne Nachlauf käme das
     Popup genau beim Tipp auf „Absenden" zurück). Beim Absenden 4 s an. Es bleibt nichts hängen. */
  var fokusTimer = null;
  var imFormular = function (el) { return !!(el && el.closest && el.closest('form[action*="/contact"]')); };
  document.addEventListener('focusin', function (e) { if (!imFormular(e.target)) return; clearTimeout(fokusTimer); html.classList.add('usp-form-fokus'); });
  document.addEventListener('focusout', function (e) {
    if (!imFormular(e.target)) return;
    clearTimeout(fokusTimer);
    fokusTimer = setTimeout(function () { if (!imFormular(document.activeElement)) html.classList.remove('usp-form-fokus'); }, 1500);
  });
  document.addEventListener('submit', function (e) {
    if (!imFormular(e.target)) return;
    clearTimeout(fokusTimer); html.classList.add('usp-form-fokus');
    fokusTimer = setTimeout(function () { if (!imFormular(document.activeElement)) html.classList.remove('usp-form-fokus'); }, 4000);
  }, true);

  /* ── Oldtimer-Fahrzeugliste ── */
  var SELBST = '__selbst';
  var daten = null, laden = null;
  function holen(url) {
    if (daten) return Promise.resolve(daten);
    if (!laden) laden = fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) { daten = j; return j; });
    return laden;
  }
  function option(text, wert) { var o = document.createElement('option'); o.textContent = text; o.value = wert == null ? text : wert; return o; }
  function jahre(m) { return m.von && m.bis ? m.von + '–' + m.bis : m.von ? 'ab ' + m.von : m.bis ? 'bis ' + m.bis : ''; }

  function liste(root) {
    root.querySelectorAll('[data-usp-ot]').forEach(function (box) {
      if (box.__uspOt) return; box.__uspOt = true;
      var hFeld = box.querySelector('[data-usp-ot-feld="hersteller"]');
      var mFeld = box.querySelector('[data-usp-ot-feld="modell"]');
      var jahrTipp = box.querySelector('[data-usp-ot-jahre]');
      if (!hFeld || !mFeld) return;
      holen(box.getAttribute('data-usp-ot-liste')).then(function (j) {
        var hersteller = (j && j.hersteller) || []; if (!hersteller.length) return;
        var hSel = document.createElement('select'); hSel.className = 'usp-input usp-ot__sel'; hSel.setAttribute('aria-label', 'Hersteller auswählen');
        var mSel = document.createElement('select'); mSel.className = 'usp-input usp-ot__sel'; mSel.setAttribute('aria-label', 'Modell auswählen');
        hSel.appendChild(option('Hersteller wählen …', ''));
        var beliebt = hersteller.filter(function (h) { return h.beliebt; });
        var g1 = document.createElement('optgroup'); g1.label = 'Häufig angefragt';
        beliebt.forEach(function (h) { g1.appendChild(option(h.name)); });
        var g2 = document.createElement('optgroup'); g2.label = 'Alle Hersteller A–Z';
        hersteller.slice().sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); }).forEach(function (h) { g2.appendChild(option(h.name)); });
        if (beliebt.length) hSel.appendChild(g1); hSel.appendChild(g2);
        hSel.appendChild(option('Nicht in der Liste – selbst eintragen', SELBST));
        hFeld.parentNode.insertBefore(hSel, hFeld); mFeld.parentNode.insertBefore(mSel, mFeld);
        hFeld.classList.add('usp-ot__frei'); mFeld.classList.add('usp-ot__frei');
        hFeld.hidden = true; mFeld.hidden = true;
        hFeld.placeholder = 'Hersteller eintragen'; mFeld.placeholder = 'Modell eintragen';
        hSel.id = hFeld.id + '-wahl'; mSel.id = mFeld.id + '-wahl';
        var labelH = box.querySelector('label[for="' + hFeld.id + '"]'); if (labelH) labelH.htmlFor = hSel.id;
        var labelM = box.querySelector('label[for="' + mFeld.id + '"]'); if (labelM) labelM.htmlFor = mSel.id;

        function modelle() {
          var h = hersteller.find(function (x) { return x.name === hSel.value; });
          mSel.innerHTML = '';
          if (!h) { mSel.appendChild(option(hSel.value === SELBST ? 'Modell unten eintragen' : 'Erst Hersteller wählen', '')); mSel.disabled = true; mSel.hidden = hSel.value === SELBST; mFeld.hidden = hSel.value !== SELBST; return; }
          mSel.disabled = false; mSel.hidden = false; mFeld.hidden = true;
          mSel.appendChild(option('Modell wählen …', ''));
          var b = (h.modelle || []).filter(function (m) { return m.beliebt; });
          var grp = function (label, arr) { if (!arr.length) return; var g = document.createElement('optgroup'); g.label = label; arr.forEach(function (m) { var o = option(m.name + (jahre(m) ? ' (' + jahre(m) + ')' : ''), m.name); o.dataset.von = m.von || ''; o.dataset.bis = m.bis || ''; g.appendChild(o); }); mSel.appendChild(g); };
          grp('Häufig', b);
          grp('Alle Modelle', (h.modelle || []).slice().sort(function (x, y) { return x.name.localeCompare(y.name, 'de'); }));
          mSel.appendChild(option('Nicht in der Liste – selbst eintragen', SELBST));
        }
        hSel.addEventListener('change', function () {
          if (hSel.value === SELBST) { hFeld.hidden = false; hFeld.value = ''; try { hFeld.focus(); } catch (_) {} }
          else { hFeld.hidden = true; hFeld.value = hSel.value; }
          mFeld.value = ''; if (jahrTipp) jahrTipp.hidden = true;
          modelle();
        });
        mSel.addEventListener('change', function () {
          if (mSel.value === SELBST) { mFeld.hidden = false; mFeld.value = ''; try { mFeld.focus(); } catch (_) {} if (jahrTipp) jahrTipp.hidden = true; return; }
          mFeld.hidden = true; mFeld.value = mSel.value;
          var o = mSel.selectedOptions && mSel.selectedOptions[0];
          if (jahrTipp && o && (o.dataset.von || o.dataset.bis)) { jahrTipp.textContent = 'Modelljahre ' + jahre({ von: +o.dataset.von || 0, bis: +o.dataset.bis || 0 }); jahrTipp.hidden = false; }
          else if (jahrTipp) jahrTipp.hidden = true;
        });
        modelle();
        // Zurücksetzen nach „Weiteres Teil anfragen" (usparts.js leert die Textfelder)
        box.closest('form').addEventListener('reset', function () { hSel.value = ''; modelle(); });
        var reset = root.querySelector('[data-usp-done-reset]'); if (reset) reset.addEventListener('click', function () { hSel.value = ''; hFeld.hidden = true; modelle(); });
      }).catch(function () { /* Liste nicht da: Textfelder bleiben — nichts verloren */ });
    });
  }
  // Formular direkt auf der Seite (Oldtimer-Seite): Liste sofort, sobald sichtbar in der Nähe
  var inline = document.querySelectorAll('main [data-usp-ot]');
  if (inline.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { liste(e.target.closest('form') || e.target); io.unobserve(e.target); } }); }, { rootMargin: '600px 0px' });
      inline.forEach(function (b) { io.observe(b); });
    } else inline.forEach(function (b) { liste(b.closest('form')); });
  }

  /* ── Weiterleitung: USt-IdNr. nur bei Gewerbe ── */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-usp-wl-typ]')) return;
    var f = e.target.closest('form'); var u = f && f.querySelector('[data-usp-wl-ustid]');
    if (u) { var gew = /gewerbe/i.test(e.target.value) && e.target.checked; u.hidden = !gew; var i = u.querySelector('input'); if (i) { i.required = gew; if (!gew) i.value = ''; } }
  });
})();
